import { render, staticRenderFns } from "./input-button.vue?vue&type=template&id=1eec53ce&scoped=true"
import script from "./input-button.vue?vue&type=script&lang=js"
export * from "./input-button.vue?vue&type=script&lang=js"
import style0 from "./input-button.vue?vue&type=style&index=0&id=1eec53ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eec53ce",
  null
  
)

export default component.exports